import React from 'react';
import "./TestQuestionNumbers.css";

function TestQuestionNumbers({ setSelectedQuestionNumber, selectedQuestionNumber, attemptedQuestions, markForReviewQuestionsArray, viewedQuestionsArray, handleFinishTest, finishTest, totalQuestions, attemptedAndMarkedForReview, isCUET }) {
  const numbers = new Array(totalQuestions).fill(0).map((_, i) => i + 1);
  const handleScrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  const selectBGColor = (number) => {
    if (number == selectedQuestionNumber) {
      if (attemptedQuestions?.includes(number)) {
        return 'answernumberActive';
      } else if (markForReviewQuestionsArray?.includes(number)) {
        return 'markedanswernumberActive';
      } else {
        return 'numberActive';
      }
    } else if (isCUET && attemptedAndMarkedForReview?.includes(number)) {
      return 'markedAsReviewAndAttempted';
    } else if (attemptedQuestions?.includes(number)) {
      return 'answernumberActive';
    } else if (markForReviewQuestionsArray?.includes(number)) {
      return 'markedanswernumberActive';
    } else if (viewedQuestionsArray?.includes(number)) {
      return 'noanswernumberActive';
    }
  }

  return (
    <div className='d-flex flex-column h-100' style={{ overflow: "hidden" }}>
      <div className='flex-grow-1' style={{ overflowY: "auto", paddingBottom: "10px" }} onClick={handleScrollToTop}>
        <ul className='number-list'>
          {numbers.map((number) => (
            <li className={selectBGColor(number)} key={number} onClick={() => setSelectedQuestionNumber(number)}>
              {number}
              {isCUET && attemptedAndMarkedForReview?.includes(number) && (
                <div className="tick-icon">✔</div>
              )}
            </li>
          ))}
        </ul>
      </div>
      {!finishTest && (
        <div className='flex-shrink-0 d-flex justify-content-center py-2 bg-white border-top'>
          <button
            type="button"
            onClick={handleFinishTest}
            style={{ backgroundColor: '#dc3545', color: 'white', border: 'none', borderRadius: '4px', padding: '10px 40px', fontWeight: 'bold' }}
          >
            Finish
          </button>
        </div>
      )}
    </div>
  );
}
export default TestQuestionNumbers;
